import { call, put, takeLatest } from "redux-saga/effects";
import { userLogin } from "../../../services/authentication";
import { loginStart, loginSuccess, loginFail } from "../reducer";
import {
  setLocalAccessToken,
  setLocalRefreshToken,
  setLocalUser,
} from "../../../utils/helpers";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* login({ payload }) {
  const { data, callback } = payload;
  const response = yield call(userLogin, data);

  const { success, raw, message, statusCode } = response;
  if (success) {
    yield put(loginSuccess(raw));
    setLocalAccessToken(raw?.accessToken || "");
    setLocalRefreshToken(raw?.refreshToken || "");
    setLocalUser(JSON.stringify(raw?.user));
    if (callback) {
      callback();
    }
  } else {
    yield put(loginFail(message));
    networkErrorHandler(statusCode, message || raw?.error);
  }
}

export default function* onLoginStart() {
  yield takeLatest(loginStart.type, login);
}
